export const getPropertyValue = property => {
  if ( property.indexOf( '.' ) !== -1 ) {
    let props = property.split( '.' );
    return host => props.reduce( ( current, key ) => getPropertyValue( key )( current ), host );
  }
  return host => host && host[property];
};

/**
 * @method calculateAmount
 * Will return a closure locking in the minimumOrderQuantity and orderQuantity
 * @param {number} minimumOrderQuantity 
 * @param {number} orderQuantity 
 * @returns a method that will calculate the current amount based on the minimum order quantity and the amount to increase
 */
export const calculateAmount = ( minimumOrderQuantity, orderQuantity ) => 
  currentAmount => 
  (currentAmount - Math.floor(currentAmount)) !== 0 ? currentAmount  : Number(Math.round((Math.max( minimumOrderQuantity, Math.ceil( currentAmount / orderQuantity ) * orderQuantity ))+'e3')+'e-3');

export const getMinOrderAmount = ( { minOrderQuantity = 1, orderQuantity = 1, baseUnitOfMeasure = "ST" } ) => {
  let minOrderAmount = minOrderQuantity;

  if ( baseUnitOfMeasure === "ST" ) {
    minOrderAmount = Math.max( minOrderQuantity, orderQuantity, 1 );
  } else if( baseUnitOfMeasure === "M" ) {
    minOrderAmount = Math.max( minOrderQuantity, 0.001 );
  }

  return minOrderAmount;
}
export const getIncrementByAmount = ( { baseUnitOfMeasure, orderQuantity = 1 } ) => {
  let incrementBy = 1;

  if ( baseUnitOfMeasure === "ST" ) {
    incrementBy = Math.max( orderQuantity, 1 );
  } else if( baseUnitOfMeasure === "M" ) {
    incrementBy = 0.001;
  }

  return incrementBy;
}